var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ls-layout', 'ls-layout-' + _vm.type]},[_c('div',{staticClass:"layout-header"},[_c('LsHeader')],1),_vm._v(" "),_c('div',{staticClass:"layout-content"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"layout-footer"},[_c('LsFooter')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322a171c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LsLayout.vue
// module id = null
// module chunks = 